import React, { memo } from 'react';
import classNames from 'classnames';
import { GLOBAL_CALENDAR_SHIFT_TYPES } from '../../constants';

import './ShiftTypeBadge.scss';

const ShiftTypeBadge = ({ shiftType }) => (
	<div
		className={classNames(
			'shift-type__shift-box__type-pill',
			`shift-type__shift-box__type-pill-${shiftType.toLowerCase()}`
		)}
	>
		{shiftType === GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND ? 'ShiftMed' : 'Flex'}
	</div>
);

export default memo(ShiftTypeBadge);
